import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { patch_CONFDEV_56476 } from './firefox';

export function patch_ie() {
	if (window.tinymce.Env.ie === 12) {
		// ms Edge has the same issue as firefox CONFDEV_56476, ie11 does not
		bind('rte-ready', patch_CONFDEV_56476);
	}
}
